// extracted by css-extract-rspack-plugin
export default {"virtualized-diff-row":"PullRequestVirtualizedDiffsList-module__virtualized-diff-row__UBneLrJ"};